<template>
  <div class="container">
    <div class="faceImg">
      <img
        :src="require('@/assets/faceImg/' + contact.img + '.jpg')"
        alt="faceImg"
      />
    </div>
    <div class="cardWrapper">
      <div
        class="text24"
        style="
           {
            margin-bottom: 0.486rem;
          }
        "
      >
        <h4>{{ contact.name }}</h4>
      </div>
      <div class="text13 textSpacing5">
        <p>{{ contact.position }}</p>
      </div>
      <div class="number">
        <img
          class="phoneIcon"
          src="@/assets/icons/phoneIcon.svg"
          alt="phoneIcon"
        />
        <a class="text13" :href="`tel:${contact.tel}`">{{ contact.tel }}</a>
      </div>
      <div class="mail">
        <img
          class="mailIcon"
          src="@/assets/icons/mailIcon.svg"
          alt="mailIcon"
        />
        <a class="text13" :href="`mailto:${contact.mail}`">{{
          contact.mail
        }}</a>
      </div>
      <div class="botIconsWrapper">
        <div>
          <a :href="contact.telegram" rel="noreferrer noopener" target="_blank">
            <img
              src="@/assets/icons/telegramIcon.svg"
              alt="telegramIcon"
              class="baseIcon"
            />
          </a>
        </div>
        <div>
          <a :href="contact.inst" rel="noreferrer noopener" target="_blank">
            <img
              src="@/assets/icons/InstagramIcon.svg"
              alt="instagramIcon"
              class="baseIcon"
            />
          </a>
        </div>
        <div>
          <a :href="contact.linkedIn" rel="noreferrer noopener" target="_blank">
            <img
              src="@/assets/icons/linkedInIcon.svg"
              alt="linkedInIcon"
              class="baseIcon"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ContactCard',
  props: {
    contact: {
      type: Object,
      required: true
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  height: auto;
  border: 2px solid #4f388d;

  a {
    text-decoration: none;
    color: #4f388d;
  }
}

.cardWrapper {
  color: #4f388d;
  padding: 2rem 0 2rem 1.25rem;
  width: 23.5rem;
}

.faceImg > img {
  width: 13.54rem;
  height: auto;
  display: block;
}

.faceImg {
  position: absolute;
  transform: translateX(-50%);
  left: 50%;
  top: -72%;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0;
}

.botIconsWrapper {
  display: flex;
  justify-content: space-between;
  padding: 0 6.52rem;
  margin-top: 3.68rem;
  margin-left: -1.25rem;
}

.baseIcon {
  height: 1.25rem;
  width: auto;
}

.number {
  display: flex;
  align-items: center;
  gap: 1.041rem;
  margin-top: 2.29rem;
}

.mail {
  display: flex;
  align-items: center;
  gap: 1.041rem;
  margin-top: 0.3rem;
}

@media screen and (max-width: 768px) {
  .container {
    width: 100%;
    padding-top: 0;
  }
  .cardWrapper {
    padding: 6.25rem 0 6.25rem 5rem;
    width: 100%;
    height: 100%;
  }
  .faceImg > img {
    width: 39rem;
    height: auto;
  }
  .faceImg {
    top: -57%;
  }

  .number {
    gap: 4.68rem;
    margin-top: 6rem;
  }

  .mail {
    gap: 4.68rem;
    margin-top: 1.5rem;
  }
  .botIconsWrapper {
    display: flex;
    justify-content: space-between;
    padding: 0 25%;
    margin-top: 9.375rem;
  }
  .baseIcon {
    height: 5rem;
    width: auto;
  }
}
</style>
